export enum DateOrigin {
    History = 1,
    Order = 2,
    Outcome = 3,
    MissingVehicles = 4,
}
